<div class="px-2 selectAreaContainer">
    <data-tree [isSelectionDialog]="true"></data-tree>
</div>
